import React, { Component } from 'react'

class Accordion extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
        }
    }

    renderChevron = () => {
        const { isOpen } = this.state
        const direction = isOpen ? 'up' : 'down'

        return <i className={`fa-regular fa-chevron-${direction}`} />
    }

    header = () => {
        const { label } = this.props
        const { isOpen } = this.state
        return (
            <div
                className={`header ${isOpen ? 'active' : ''}`}
                onClick={() => this.setState({ isOpen: !isOpen })}
            >
                {label}
                {this.renderChevron()}
            </div>
        )
    }

    body = () => {
        const { onAdd, children } = this.props
        const { isOpen } = this.state

        if (!isOpen) return null

        return (
            <div className="body">
                {children}
            </div>
        )
    }

    render() {
        return (
            <div className="uc-accordion">
                {this.header()}
                {this.body()}
            </div>
        )
    }
}

export default Accordion
